class LoggerNullConnector
{

    log(source, level, message, context)
    {
        // do nothing
    }

}

export default LoggerNullConnector;